import { css } from "@emotion/react";

const buttonCopy = props => css`
  display: none;
  @media (min-width: ${props.theme.screenSizes.mdMax}) {
    display: inline-block;
    & svg {
      height: 24px;
      width: 24px;
    }
  }
`;

const button = css`
  width: 100%;
  margin-top: 24px;
`;

const wrapper =
  (type, button) =>
  ({ theme }) => css`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    ${type === "anonymity" &&
    !button &&
    css`
      border-bottom-left-radius: 0;

      @media (min-width: ${theme.screenSizes.mdMax}) {
        border-bottom-left-radius: 20px;
      }

      border-bottom-right-radius: 0;

      @media (min-width: ${theme.screenSizes.mdMax}) {
        border-bottom-right-radius: 20px;
      }
    `}
  `;

export const addStyles = {
  wrapper,
  buttonCopy,
  button,
};
